<template>
    <!-- <div class="sticky" v-if="image"> -->
		<div class="flexbox-container--exhaust-diagram sticky" id="ExhaustDiagram" v-if="hasGallery" :style="toggleDiagram">
			<div class="card sticky">
				<div class="container">
					<div class="center-elements-image-parts-diagram">
						<div class="product-gallery product-gallery--layout--product-sidebar product__gallery" data-layout="product-sidebar">
							<div id="my-gallery" style="margin:auto"></div>
							<!-- <img :src="image" class="center-elements-image" /> -->
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="products-view__options view-options view-options--offcanvas--mobile" v-if="hasGallery">	                                            											
			<div class="view-options__body view-options__body-dark-grey">		
				<button class="btn btn-small btn-dark-blue btn-check-stock" @click="showImage = !showImage">Show/Hide Diagram</button>										
			</div>                                            
		</div>
	
</template>

<script>
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import * as GCONST from '../../../constants.js';

export default {
	props : {
		diagram_img : {
			type : String
		}
	},

	data() {
		return {
			image : null,
			hasGallery: false,
			showImage : true,
		}
	},

	computed: {
		toggleDiagram() {
			let style = '';
			if(this.showImage){
				style = 'display:block';
			}else{
				style = 'display:none';
			}
			return style;
		}
	},
	methods: {
		getDiagramImg(){
			let level = this.$route.params.level;
			let lvl = 1;
			let l = '';
			// console.log(level);
			// const parentLevel = level - 1;
			if(level < 10){
                l = '0' + level;
            }else{
				l = level;
			}
            const categories = this.$store.getters['product/categories'];
            let currentcategory = categories.filter((cat) => (cat['DMCD' + l] == this.$route.params['categoryUri' + level] && cat.categorylevel == level));
			while(lvl <= level){
              if(lvl < 10){
                  l = '0' + lvl;
              }else{
                  l = lvl;
              }
              currentcategory = currentcategory.filter((cat) => cat['DMCD' + l] == this.$route.params['categoryUri' + lvl]);
              lvl++;
            }

			// if current category not found
			// redirect to 404 page
			if (currentcategory == undefined){
				this.$router.push('/404');
				return;
			}else{
				currentcategory = currentcategory[0];
			}

			const clApi = new CloudinaryApi;

			clApi.diagram_id = currentcategory['DMCD' + level];
			clApi.category_level = currentcategory.categorylevel;
			clApi.category_codes.push({
				metakey : GCONST.CL_META_CATEGORY_ID,
				metavalue: currentcategory.DMCD01});
			clApi.category_codes.push({
				metakey : GCONST.CL_META_CATEGORY_ID_2,
				metavalue: currentcategory.DMCD02});
			clApi.category_codes.push({
				metakey : GCONST.CL_META_CATEGORY_ID_3,
				metavalue: currentcategory.DMCD03});
			clApi.category_codes.push({
				metakey : GCONST.CL_META_CATEGORY_ID_4,
				metavalue: currentcategory.DMCD04});
			clApi.category_codes.push({
				metakey : GCONST.CL_META_CATEGORY_ID_5,
				metavalue: currentcategory.DMCD05});
			clApi.category_codes.push({
				metakey : GCONST.CL_META_CATEGORY_ID_6,
				metavalue: currentcategory.DMCD06});
			clApi.category_codes.push({
				metakey : GCONST.CL_META_CATEGORY_ID_7,
				metavalue: currentcategory.DMCD07});
			clApi.category_codes.push({
				metakey : GCONST.CL_META_CATEGORY_ID_8,
				metavalue: currentcategory.DMCD08});
			clApi.category_codes.push({
				metakey : GCONST.CL_META_CATEGORY_ID_9,
				metavalue: currentcategory.DMCD09});
			clApi.category_codes.push({
				metakey : GCONST.CL_META_CATEGORY_ID_10,
				metavalue: currentcategory.DMCD10});

			// large image
			clApi.vlWidgetGallery(GCONST.CL_META_DIAGRAM_ID).then(imgGallery => {
				if(imgGallery){
					// sort the array by sequence
					imgGallery.sort((a,b) => (a.sequence > b.sequence) ? 1 : ((b.sequence > a.sequence) ? -1 : 0));
					const myWidget = window.cloudinary.galleryWidget({
						'cloudName': 'dms-systems',
						"mediaAssets" : imgGallery,
						"carouselLocation": "bottom",
						"carouselStyle" : "none",
						"container": '#my-gallery',
						"zoomProps": {
							"trigger": "click"
						},
					});
					myWidget.render();
					this.hasGallery = true;
				}else{
					this.hasGallery = false;
				}
			});
		}
	},
	created() {
		this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
		
		this.getDiagramImg();

		// console.log(this.diagram_img);
		// const code = this.$route.params.subCatUri;
		// const categories = this.$store.getters['product/categories'];
		// const img_domain_cat = this.$store.getters['image_domain_category'];
		// const currentcategory = categories.find((cat) => (cat.categorycode === code));
		// const parentCategory = categories.find((cat) => (cat.categorycode === currentcategory.DMCD01));
		// // console.log('current diagram = ' + currentcategory.categorydiagramimage);
		// console.log('parentCategory = ' + parentCategory.categorydiagramimage);
		// console.log('currentcategory = ' + currentcategory.categorydiagramimage);

		// if (parentCategory.categorydiagramimage != '') {
		// 	// this.image = 'http://dev.qwik-order.com/cePartsImages/' + parentCategory.categorydiagramimage;
		// 	// this.image = img_domain_cat + '/' + parentCategory.categorydiagramimage;
		// 	// this.image = 'https://via.placeholder.com/350';

		// 	const clApi = new CloudinaryApi;
        //     clApi.diagram_id = parentCategory.DMCD01;

        //     clApi.vlImageByMeta(GCONST.CL_META_DIAGRAM_ID, GCONST.Parts_Diagram).then(imgURL => {
        //         if(imgURL){
        //             this.image = imgURL;
        //         }else{
        //             this.image = GCONST.IMAGE_PLACEHOLDER;
        //         }
        //     });
		// }else{
		// 	this.image = null;
		// }
	}
}
</script>

<style scoped>
	.flexbox-container--parts-diagram.sticky{
		width: 100%;
	}
</style>